import React, { useState, useCallback } from 'react'
import { createRoot } from 'react-dom/client'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd'
import { ApolloProvider, useMutation } from '@apollo/client'
import debounce from 'debounce'
import update from 'immutability-helper'
import Bank from '../components/bank'
import client from '../client'
import sortBanks from '../mutations/sort-banks'

const BankList = ({ banks: initialBanks }) => {
  const [banks, setBanks] = useState(initialBanks)
  const [sortBanksMutation] = useMutation(sortBanks)

  const dispatchSort = useCallback(
    debounce(() => {
      const ids = banks.map((b) => b.id)
      const expected = ids.map((id, i) => ({ id, sortOrder: i }))

      sortBanksMutation({
        variables: { ids },
        optimisticResponse: {
          sortBanks: expected,
        },
      })
    }, 500),
    [banks, sortBanksMutation]
  )

  const moveBank = (dragIndex, hoverIndex) => {
    const dragBank = banks[dragIndex]
    setBanks(
      update(banks, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragBank],
        ],
      })
    )
    dispatchSort()
  }

  const showArchiveStatus = (bank) => {
    if (bank.archived) {
      return <span className="bold">hidden</span>
    }
    return (
      <i style={{ color: '#1DAEA6' }} className="material-icons">
        done
      </i>
    )
  }

  const countWidth = { width: '50px', textAlign: 'center' }
  const nameWidth = { width: '300px' }
  const center = { textAlign: 'center' }

  return (
    <table>
      <thead>
        <tr>
          <th style={nameWidth}>Name</th>
          <th style={center}>Questions</th>
          <th style={countWidth} title="Initial">
            In
          </th>
          <th style={countWidth} title="Mid-stream">
            Mi
          </th>
          <th style={countWidth} title="Wrap-up">
            Wu
          </th>
          <th style={countWidth} title="Meta">
            Me
          </th>
          <th style={center}>Visibility</th>
          <th style={center}>Hide/Unhide</th>
        </tr>
      </thead>
      <tbody>
        {banks.map((b, i) => (
          <Bank
            index={i}
            data={b}
            key={b.id}
            bank={b}
            moveBank={moveBank}
            showArchiveStatus={showArchiveStatus}
          />
        ))}
      </tbody>
    </table>
  )
}

const bankList = document.getElementById('bank-list')
if (bankList) {
  const csrfTag = document.querySelector('meta[name=csrf-token]')
  const csrfToken = csrfTag.getAttribute('content')
  const banks = JSON.parse(bankList.getAttribute('data-banks'))
  const props = { csrfToken, banks }

  const root = createRoot(bankList)
  root.render(
    <ApolloProvider client={client}>
      <DndProvider backend={HTML5Backend}>
        <BankList {...props} />
      </DndProvider>
    </ApolloProvider>
  )
}
